import { Helmet } from 'react-helmet'
import CTAButton from '../../components/CTAButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone, faRobot, faHouse, faAddressCard, faGlobe } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { oPU } from '../../core.js'

import logo_main from '../../assets/pictures/logos/ToN-25-Logo-oT-light-long.webp'
import pb_david from '../../assets/pictures/pb_david.webp'
import './Visitenkarte.css'
import './MVisitenkarte.css'
import MainHeader from '../../components/MainHeader.js'

const CALENDLY = 'https://calendly.com/tonetworkde-meet/getintouch'

export default function Visitenkarte() {
    return (
        <div className="mainCon" id="mainCon--visitenkarte">

            <MainHeader funnel disableanimation={true} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>David Heidl – ToNetwork</title>
                <meta name="description" content="David Heidl, Gründer von ToNetwork UG. Webentwicklung, Fotografie, KI & Media aus dem Allgäu. Kontakt und Infos auf einen Blick." />
                <meta property="og:title" content="David Heidl – ToNetwork" />
                <meta property="og:description" content="Gründer & Geschäftsführer ToNetwork UG – Digitalisierung aus dem Allgäu." />
                <meta property="og:type" content="profile" />
            </Helmet>

            <section className="sec_next" id="sec_next--visitenkarte">
                <div className="sec_next_cont" id="sec_next--visitenkarte--cont">

                    {/* <a href="/" aria-label="ToNetwork – zur Startseite" className="visitenkarte_logo_link">
                        <img src={logo_main} alt="ToNetwork Logo" className="visitenkarte_logo" />
                    </a> */}

                    <div className="visitenkarte_hero">
                        <img src={pb_david} className="visitenkarte_photo" alt="David Heidl, Gründer ToNetwork" />
                        <h2>David Adrian Heidl</h2>
                        <h3>Gründer &amp; Geschäftsführer · ToNetwork UG</h3>
                        <p className="visitenkarte_tagline">
                            Webentwicklung, Fotografie, KI &amp; Media – aus dem Allgäu, aus einer Hand.
                        </p>
                    </div>

                    <div className="visitenkarte_block">
                        <h3>Über mich</h3>
                        <p>
                            Technikliebhaber mit Faible für Webdesign, Fotografie und KI.
                            Nach dem dualen Studium Wirtschaftsinformatik beim ADAC setze ich bei ToNetwork
                            auf pragmatische Digitalisierung – persönlich, langfristig und ohne Agentur-Overhead.
                        </p>
                        <p className="visitenkarte_quote">
                            „Gute Lösungen entstehen durch breites Verständnis – und den Blick fürs Wesentliche.“
                        </p>
                        <div className="visitenkarte_socials">
                            <a href="https://www.linkedin.com/in/david-adrian-heidl/" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                <FontAwesomeIcon icon={faLinkedin} />
                            </a>
                            <a href="https://instagram.com/davidfilmt" target="_blank" rel="noopener noreferrer" title="@davidfilmt">
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                            <a href="https://davidfilmt.de" target="_blank" rel="noopener noreferrer" title="davidfilmt.de">
                                <FontAwesomeIcon icon={faGlobe} />
                            </a>
                            <a href="https://wa.me/+4915792358626" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                                <FontAwesomeIcon icon={faWhatsapp} />
                            </a>
                        </div>
                    </div>

                    <div className="visitenkarte_block visitenkarte_contact">
                        <h3>Kontakt</h3>
                        <ul className="visitenkarte_contact_list">
                            <li>
                                <a href="mailto:hey@tonetwork.de">
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    <span>hey@tonetwork.de</span>
                                </a>
                            </li>
                            <li>
                                <a href="tel:+4983324908872">
                                    <FontAwesomeIcon icon={faPhone} />
                                    <span>+49 8332 4908872</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://wa.me/+4983324908872">
                                    <FontAwesomeIcon icon={faWhatsapp} />
                                    <span>+49 1579 2358626</span>
                                </a>
                            </li>
                            <li>
                                <a href="/chat">
                                    <FontAwesomeIcon icon={faRobot} />
                                    <span>ToNi KI Assistent</span>
                                </a>
                            </li>
                            {/* <li>
                                <span className="visitenkarte_contact_static">
                                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                                    <span>Im Moos 5 · 87749 Hawangen · Allgäu</span>
                                </span>
                            </li> */}
                        </ul>
                        <div className="visitenkarte_cta_row">
                            <CTAButton
                                showArrow={false}
                                customIcon={faPhone}
                                iconLeft={true}
                                title="Erstgespräch buchen"
                                onclick={() => { oPU(CALENDLY) }}
                            />
                            <CTAButton
                                showArrow={false}
                                customIcon={faAddressCard}
                                iconLeft={true}
                                title="Kontakt speichern"
                                href="/David-Heidl-ToNetwork.vcf"
                                download="David-Heidl-ToNetwork.vcf"
                            />
                            <CTAButton
                                className="visitenkarte_cta_secondary"
                                showArrow={true}
                                lightcta={true}
                                title="Zum Kontaktbereich"
                                href="/support"
                            />
                        </div>
                    </div>

                    <div className="visitenkarte_block visitenkarte_company">
                        <h3>ToNetwork</h3>
                        <p>
                            ToNetwork UG ist dein persönlicher Partner für die digitale Welt –
                            aus Hawangen im Unterallgäu für KMU, Startups, Vereine und Veranstalter
                            in Memmingen, Allgäu und darüber hinaus.
                        </p>
                        <ul className="visitenkarte_services">
                            <li>Web- &amp; Appentwicklung</li>
                            <li>Hosting &amp; Betreuung in Deutschland</li>
                            <li>Fotografie, Video &amp; Social Content</li>
                            <li>KI-Beratung &amp; Automatisierung</li>
                        </ul>
                        <div className="visitenkarte_links">
                            <a href="/services" className="sec_next_link">Leistungen</a>
                            <span>·</span>
                            <a href="/pricing" className="sec_next_link">Preise</a>
                            <span>·</span>
                            <a href="/about" className="sec_next_link">Über uns</a>
                        </div>
                        <div className="visitenkarte_cta_row visitenkarte_cta_row-company">
                            <CTAButton
                                showArrow={false}
                                customIcon={faHouse}
                                iconLeft={true}
                                title="Zur Homepage"
                                href="/"
                            />
                        </div>
                    </div>

                    <p className="visitenkarte_legal">
                        ToNetwork UG (haftungsbeschränkt)<br />
                        <a href="/rechtliches/impressum">Impressum</a>
                        {' · '}
                        <a href="/rechtliches/datenschutz">Datenschutz</a>
                    </p>

                </div>
            </section>
        </div>
    )
}
